/* @flow */
import { createAction } from "redux-actions";
import * as ActionTypes from "../../../actionTypes";
import WorkFlowController from "../../../services/workflowController";
import { userAccessTokenSelector } from "../../../security";

const workflowController = new WorkFlowController();

type Action = {
  +type: string,
  +payload?: any,
  +error?: boolean,
  +meta?: any
};

export const fetchRatesRequested: Action = createAction(
  ActionTypes.FETCH_RATES_REQUESTED
);
export const fetchRatesReceived: Action = createAction(
  ActionTypes.FETCH_RATES_RECEIVED
);
export const fetchRatesFailed: Action = createAction(
  ActionTypes.FETCH_RATES_FAILED
);

const fetchAllRatesAPI = async options =>
  await workflowController.findByFilter(
    "rate",
    {
      order: ["locationId", "description"],
      paging: false
    },
    options
  );
export const fetchAllRates = () => async (dispatch, getState) => {
  dispatch(fetchRatesRequested());
  try {
    const result = await fetchAllRatesAPI({
      token: userAccessTokenSelector(getState())
    });
    dispatch(fetchRatesReceived(result));
  } catch (err) {
    dispatch(fetchRatesFailed(err.message[0].msg));
  }
};

export const configureRateRequested: Action = createAction(
  ActionTypes.CONFIGURE_RATE_REQUESTED
);
export const configureRateReceived: Action = createAction(
  ActionTypes.CONFIGURE_RATE_RECEIVED
);
export const configureRateFailed: Action = createAction(
  ActionTypes.CONFIGURE_RATE_FAILED
);

const configureRateAPI = async (data, options) =>
  await workflowController.execute("rate", null, "configure_v3", data, options);
export const configureRate = (
  rateValue,
  rateDescription,
  rateCategory,
  unit,
  billingType,
  accountType,
  locationId
) => async (dispatch, getState) => {
  dispatch(configureRateRequested());
  try {
    await configureRateAPI(
      {
        rateDescription,
        rateCategory,
        rateValue,
        unit,
        billingType,
        accountType,
        locationId
      },
      { token: userAccessTokenSelector(getState()) }
    );
    dispatch(configureRateReceived());
    dispatch(fetchAllRates());
    return true;
  } catch (err) {
    dispatch(configureRateFailed(err.message[0].msg));
    return false;
  }
};

export const unSetRateError: Action = createAction(
  ActionTypes.UNSET_RATE_ERROR
);

export const deleteRateRequested: Action = createAction(
  ActionTypes.DELETE_RATE_REQUESTED
);
export const deleteRateReceived: Action = createAction(
  ActionTypes.DELETE_RATE_RECEIVED
);
export const deleteRateFailed: Action = createAction(
  ActionTypes.DELETE_RATE_FAILED
);

const deleteRateAPI = async (rateId, options) =>
  await workflowController.execute("rate", null, "delete", { rateId }, options);
export const deleteRate = rateId => async (dispatch, getState) => {
  dispatch(deleteRateRequested());
  try {
    await deleteRateAPI(rateId, { token: userAccessTokenSelector(getState()) });
    dispatch(deleteRateReceived());
  } catch (err) {
    dispatch(deleteRateFailed("There was a problem deleting rates."));
  }
};

export const editRateRequested: Action = createAction(
  ActionTypes.EDIT_RATE_REQUESTED
);
export const editRateReceived: Action = createAction(
  ActionTypes.EDIT_RATE_RECEIVED
);
export const editRateFailed: Action = createAction(
  ActionTypes.EDIT_RATE_FAILED
);

const editRateAPI = async (data, options) =>
  await workflowController.execute("rate", null, "edit_v3", data, options);
export const editRate = ({
  rateId,
  description,
  group,
  value,
  unit,
  billingType,
  accountType,
  locationId
}) => async (dispatch, getState) => {
  dispatch(editRateRequested());
  try {
    await editRateAPI(
      {
        rateId,
        description,
        group,
        value: parseFloat(value),
        unit,
        billingType,
        accountType,
        locationId
      },
      { token: userAccessTokenSelector(getState()) }
    );
    dispatch(editRateReceived());
    dispatch(fetchAllRates());
    return true;
  } catch (err) {
    dispatch(editRateFailed(err.message[0].msg));
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/features/rate/store/rateActions.js